import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  sortSelect: {
    "& .MuiInputLabel-root": {
      margin: 0,
    },
    "& .MuiSelect-select.MuiSelect-select": {
      fontWeight: 500,
    },
  },
  ratingTxt: {
    fontSize: 14,
    lineHeight: "14px",
    paddingRight: 15,
    marginRight: 15,
    // borderRight: "solid 1px #707070",
  },
  // accordion style
  accordion: {
    boxShadow: "none",
    "&:before": {
      background: "none",
    },
    border: "solid 1px rgb(112 112 112 / 11%)",
    borderRadius: "8px !important",
    marginBottom: 12,
    padding: 0,
    "&.Mui-expanded": {
      "& .MuiAccordionSummary-root": {
        background: "#F8F7F8",
        borderRadius: "7px 7px 0 0",
        color: "#000000",
      },
      "& .MuiAccordionSummary-expandIcon": {
        background: "#EEEDEE",
        border: "solid 1px #D0D0D1",
        "& svg": {
          color: "#858585",
        },
      },
    },
    "& .MuiAccordionSummary-root": {
      padding: "2px 12px",
    },
  },
  accordionSummary: {
    padding: 0,
    flexDirection: "row-reverse",
    height: "55px !important",
    minHeight: "55px !important",
    "& .MuiIconButton-root": {
      padding: 0,
      background: "#EEEEEE",
      borderRadius: 3,
      marginRight: 15,
    },
    "& .MuiSwitch-root": {
      marginLeft: 20,
      "& .MuiIconButton-root": {
        background: "unset !important",
        marginRight: "0 !important",
        padding: "9px !important",
        borderRadius: "unset !important",
      },
    },
    "& .MuiAccordionSummary-content": {
      alignItems: "center",
    },
  },
  accordionDetails: {
    padding: "0 16px 16px",
    display: "block",
    background: "rgb(237 238 239 / 45%)",
    [theme.breakpoints.down("xs")]: {
      padding: "0 8px 16px",
    },
    "& p": {
      margin: 0,
    },
  },
  //  accordion style end
  gridView: {
    "& td": {
      background: "rgb(237 238 239 / 45%)",
      borderBottomColor: "#CAD4DD",
    },
    "& .k-grid .k-grid-header-wrap": {
      borderBottom: "solid 1px #CAD4DD",
    },
    "& .k-grid-header": {
      background: "transparent",
    },
  },
  never: {
    background: "#FC7F60",
  },
  often: {
    background: "#50449C",
  },
  sometimes: {
    background: "#17CDD4",
  },
  rarely: {
    background: "#FDA457",
  },
  notApplicable: {
    background: "#CAD4DD",
  },
  chartLegend: {
    marginLeft: "20%",
    "& .dot-indicator": {
      margin: "0 5px 0 0",
    },
  },
  donutChart: {
    borderLeft: "solid 1px #CACBC3",
    paddingLeft: 30,
    paddingBottom: 40,
    "& .k-chart": {
      height: 250,
    },
  },
  checkinDetailGrid: {
    background: "rgb(237 238 239 / 45%)",
  },
  legendList: {
    width: "50%",
    float: "left",
  },
  srsQusView: {
    "& .k-grid-header": {
      display: "none",
    },
    "& .k-detail-row": {
      "& .k-grid-header": {
        display: "flex",
      },
    },
  },
  srsGridView: {
    "& .k-grid-header": {
      padding: "0 !important",
    },
  },
}));
